export const priceIndex = {
  '9798990416529': {
    title: 'Grocery List',
    prod: 'price_1PTAz2FoScMjUSrm2WfnV996',
    test: 'price_1PTBM1FoScMjUSrmDaiSQ6l4'
  },
  '9798990416512': {
    title: 'Frontier Index',
    prod: 'price_1QK7xcFoScMjUSrmoaNSPo2g',
    test: 'price_1QK3jlFoScMjUSrmjcplpfDi'
  },
  '9798990416505': {
    title: 'Insistence as a Fine Art',
    prod: 'price_1QK7yUFoScMjUSrm8LVWoSxV',
    test: 'price_1QK3rqFoScMjUSrmT9xu5wp4'
  },
  '9798989378098': {
    title: 'The Kuruntokai and Its Mirror',
    prod: 'price_1QK7zRFoScMjUSrmQQ15TYRL',
    test: 'price_1QK3sdFoScMjUSrmCHGj9jI8'
  },
  '9798989378081': {
    title: 'Fan Mail, Frank Letters and Crank Calls',
    prod: 'price_1TfoT2FoScMjUSrmHKtqW1Ef',
    test: 'price_1QK3txFoScMjUSrmis4rzQpf'
  },
  '9798989378067': {
    title: 'Life Story',
    prod: 'price_1QK7zzFoScMjUSrmjVAxY1Qr',
    test: 'price_1PTFJUFoScMjUSrmH8cmBjy9'
  },
  '9798989378043': {
    title: 'Bread and Water',
    prod: 'price_1Tfo6XFoScMjUSrm9IPqQf9B',
    test: 'price_1QK45XFoScMjUSrmEuDLKEfY'
  },
  '9798989378036': {
    title: 'Garden of Ashes',
    prod: 'price_1TfoNSFoScMjUSrmhMIaMrg6',
    test: 'price_1QK46aFoScMjUSrmXasR7KO4'
  },
  '9798989378050': {
    title: 'The Lie of the Truth',
    prod: 'price_1QK84hFoScMjUSrmfOan4GbD',
    test: 'price_1QK47AFoScMjUSrmsUrDOVl2'
  },
  '9798989378029': {
    title: 'Feminine Hijinx',
    prod: 'price_1QK83tFoScMjUSrmQlWAUPgt',
    test: 'price_1QK4CiFoScMjUSrmCDRW5eCe'
  },
  '9798989378012': {
    title: 'The Ice Storm',
    prod: 'price_1TfoHiFoScMjUSrmE3s1GUYx',
    test: 'price_1QK4DVFoScMjUSrmjIYxoUos'
  },
  '9798989378005': {
    title: 'On My Painting',
    prod: 'price_1QK85qFoScMjUSrmGTpUp1Pv',
    test: 'price_1QK4DwFoScMjUSrm72esR3hO'
  },
  'hanuman_box_02_tb': {
    title: 'Tabriz Box',
    prod: 'price_1QK88dFoScMjUSrmMk2uI3ul',
    test: 'price_1QK4FgFoScMjUSrm0UEFHp5S'
  },
  'hanuman_box_02_ct': {
    title: 'Citrine Box',
    prod: 'price_1QK876FoScMjUSrmywTWW7eu',
    test: 'price_1QK4F7FoScMjUSrmrk5JOOrb'
  },
  'hanuman_box_02_nb': {
    title: 'New Blue Box',
    prod: 'price_1Pu1z5FoScMjUSrmbNK2ZDX7',
    test: 'price_1QK4FzFoScMjUSrmYBKtVdUz'
  },
  'hanuman_box_02_fl': {
    title: 'Flamingo Box',
    prod: 'price_1QK87qFoScMjUSrm5gBshLJ8',
    test: 'price_1QK4GHFoScMjUSrmh5HNuRlR'
  },
  '9798990416574': {
    title: 'Space Opera',
    prod: 'price_1RYAI7FoScMjUSrmr3QZdC5d',
    test: 'price_1QK4CiFoScMjUSrmCDRW5eCe'
  },
  '9798990416567': {
    title: 'The History of the Dolls and What They Did',
    prod: 'price_1RYAINFoScMjUSrm48wMuXnb',
    test: 'price_1QK4DVFoScMjUSrmjIYxoUos'
  },
  '9798990416550': {
    title: "Mishima's Head",
    prod: 'price_1RYAIcFoScMjUSrmII1VatFa',
    test: 'price_1QK4DwFoScMjUSrm72esR3hO'
  },
  '9798990416543': {
    title: 'Love Never Dies',
    prod: 'price_1RYAIqFoScMjUSrm2snr137C',
    test: 'price_1QK4CiFoScMjUSrmCDRW5eCe'
  },
  '9798990416536': {
    title: 'Fuck Journal',
    prod: 'price_1TfoXVFoScMjUSrmFZSqoU7k',
    test: 'price_1QK4DVFoScMjUSrmjIYxoUos'
  },
  '9798989378074': {
    title: 'Kafka & I',
    prod: 'price_1RYAJJFoScMjUSrmx8KhbTjQ',
    test: 'price_1QK4DwFoScMjUSrm72esR3hO'
  },
  'hanuman_box_03_mg': {
    title: 'Hanuman Series III Mid Green Box',
    prod: 'price_1RqenpFoScMjUSrmiyp4hXPG',
    test: 'price_1RqenpFoScMjUSrmiyp4hXPG'
  },
  'hanuman_box_03_rs': {
    title: 'Hanuman Series III Rose Box',
    prod: 'price_1RqenMFoScMjUSrm7PEh9vWN',
    test: 'price_1RqenMFoScMjUSrm7PEh9vWN'
  },
  'hanuman_box_03_pp': {
    title: 'Hanuman Series III Purple Box',
    prod: 'price_1RqemwFoScMjUSrmz9tG7qTt',
    test: 'price_1RqemwFoScMjUSrmz9tG7qTt'
  },
  'hanuman_box_03_ny': {
    title: 'Hanuman Series III Neon Yellow Box',
    prod: 'price_1RqemVFoScMjUSrmRsJ9cb6q',
    test: 'price_1RqemVFoScMjUSrmRsJ9cb6q'
  },
  '9798995641001': {
    title: '1969',
    prod: 'price_1Tfo24FoScMjUSrmPOTvzAqi',
    test: 'price_1Tfo24FoScMjUSrmPOTvzAqi'
  },
  '9798990416581': {
    title: 'By Surprise',
    prod: 'price_1Tfo17FoScMjUSrmrQXM967x',
    test: 'price_1Tfo2lFoScMjUSrmh7n9sH8X'
  },
  '9798990416598': {
    title: "On the Lord's Prayer",
    prod: 'price_1Tfo1aFoScMjUSrmMSECA6hX',
    test: 'price_1Tfo17FoScMjUSrmrQXM967x'
  }
}